import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

const initialState = {
  partners: [],
  status: 'idle',
  currentPage: 1,
  totalPages: 1,
  error: null,
};

export const fetchPartners = createAsyncThunk(
  'super-admin/fetch-partners',
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `super-admin/partners?page=${page}&limit=${limit}`
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.msg);
    }
  }
);

export const partnersSlice = createSlice({
  name: 'partners',
  initialState,
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setPartnerCategory(state, action) {
      const partner = state.partners.find((p) => p.admin_id === action.payload.admin_id);
      if (partner) partner.category = action.payload.category;
    },
    setTotalPages(state, action) {
      state.totalPages = Math.ceil(
        state.totalCount / action.payload.newItemsPerPage
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPartners.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPartners.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.partners = [...action.payload.partners];
        state.totalPages = Math.ceil(
          action.payload.totalCount / action.meta.arg.limit
        );
      })
      .addCase(fetchPartners.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'An error occured';
      });
  },
});

export const { setCurrentPage, setTotalPages, setPartnerCategory } = partnersSlice.actions;

export default partnersSlice.reducer;
